import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { IonInput } from '@ionic/angular';
import { from } from 'rxjs';
import { FileType } from '../../../domains/models/generic-file';
import { PendingFile } from '../../../domains/models/pending-file';
import { User } from '../../../domains/users';
import { UserFile } from '../../../domains/users/user-files/user-file.model';
import { InstallerProfileForm } from '../../../modals/installer-profile/installer-profile.form';
import { HasTargetFiles } from '../../utils/types';

@Component({
  selector: 'gc-insurance-info-form',
  templateUrl: './insurance-info-form.component.html',
  styleUrls: ['./insurance-info-form.component.scss'],
})
export class InsuranceInfoFormComponent {
  @Input() validated = false;
  @Input() form!: InstallerProfileForm;
  @Input() user!: User;
  @Input() files!: UserFile[];
  @Output() fileAdded = new EventEmitter<{ user: User; file: PendingFile }>();

  addPendingFiles(files: File[]) {
    files
      .map((file: File) => ({
        type: FileType.Insurance,
        filename: file.name,
        contentType: file.type,
        fileBlob: file,
      }))
      .forEach(file => {
        this.fileAdded.emit({
          user: this.user,
          file,
        });
      });
  }

  async addFiles($event: Event & HasTargetFiles): Promise<void> {
    this.addPendingFiles(Array.from($event.target.files));
  }

  addDroppedFiles(files: FileList): void {
    this.addPendingFiles(Array.from(files));
  }
}
